import {URL_SURVEY_API} from "../utils/constEnvVariables";

export function getHelpDocPdf(accessToken){
    const requestOptions = {
        method: 'GET',
        responseType: 'blob',
        mode: "cors",
        cache: "default",
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }

    return fetch(`${URL_SURVEY_API}/surveys/tpsmex/helpdocpdf`, requestOptions)
        .then(response => {
            return response
        })
}